import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { FormattedMessage, useIntl } from "react-intl";
import { useLocation } from "react-router-dom";

import { CreateNextPossibleStatusDTO } from '../../models/Status/CreateNextPossibleStatusDTO';
import { StatusService } from '../../services/StatusService';

import Toast from "../../helpers/Toast";

import { SelectItemsProps } from "../../components/Select2Component";
import SelectComponent from "../../components/SelectComponent";
import useValidationSchema, { FieldConfig } from "../../components/Validations";
import ButtonComponent from '../../components/ButtonComponent';
import InputComponent from "../../components/InputComponent";
import Layout from '../../components/Layout/Layout';
import PageTitle from '../../components/Layout/PageTitle';
import { CreateNewStatusDTO } from '../../models/Status/CreateNewStatusDTO';
import { PipeDTO } from '../../models/Pipe/PipeDTO';

// type NextPossibleStatusProps = {
//     BaseStatus: string;
//     baseStatusName: string;
// }

export default function StatusCreate(){
    const statusService = new StatusService();
    const [possibleStatus, setPossibleStatus] = useState<CreateNextPossibleStatusDTO>({} as CreateNextPossibleStatusDTO);
    const [status, setStatus] = useState<SelectItemsProps[]>([]);
    const [newStatus, setNewStatus] = useState<CreateNewStatusDTO>({} as CreateNewStatusDTO);

    const [pipes, setPipes] = useState<SelectItemsProps[]>([]);
    const [namePipe, setNamePipe] = useState<PipeDTO>({} as PipeDTO);


    const location = useLocation();
    const baseStatusProps = location.state?.baseStatusName ?? null;

    const [loading, setLoading] = useState(false);

    const intl = useIntl();

    //Realizar isto, falta o service
    const getAllStatus = async () => {

      var response = await statusService.GetAllStatus();

      if (response.success === false || response.obj === null) {
        Toast.Show("error", response.message);
        return [];
      }

      const list: SelectItemsProps[] = [];
      
      response.obj.forEach((element) => {
        var item: SelectItemsProps = {
          value: element.name,
          label: element.name,
        };
        list.push(item);
      });

      setStatus(list);
    };

    useEffect(() => {
      getAllStatus();
    }, []);

    // useEffect(() => {//first time it doesn't work
    //   if(baseStatusProps){
    //     possibleStatus.baseStatusName = baseStatusProps;
    //   }
    // }, [baseStatusProps]);

    const fields: FieldConfig[] = [
      ["baseStatusName", "string", "Screens.Status.Create.FirstStatusRequired"],
      ["nextStatusName", "string", "Screens.Status.Create.NextStatusRequired"]
    ]

    const secondFields: FieldConfig[] = [
      ["name", "string", "Screens.Status.Create.Name"],
      ["name", "string", "Screens.Status.Create.Pipe"],
    ]

    const schemaClientValidation = useValidationSchema(fields);
    const schemaNewStatusValidation = useValidationSchema(secondFields);

    //obter tipo de processo
    const getAllPipes = async () => {

      var response = await statusService.GetAllPipes();

      if (response.success === false || response.obj === null) {
        Toast.Show("error", response.message);
        return [];
      }

      const list: SelectItemsProps[] = [];
      
      response.obj.forEach((element) => {
        var item: SelectItemsProps = {
          value: element.name,
          label: element.name,
        };
        list.push(item);
      });

      setPipes(list);
    }

    useEffect(() => {
      getAllPipes();
    }, []);

  //Criar novo estado
  const CreateStatus = async () => {
    setLoading(true);

    const CreateNewStatus: CreateNewStatusDTO = {
      name: newStatus?.name ?? null,
      active: true,
      idPipe: newStatus?.idPipe ?? null,
      statusEnumValue: newStatus?.name ?? null,
      frontendName: newStatus?.frontendName ?? "",
      frontendOrder: newStatus?.frontendOrder ?? null,
    };

    const { error } = schemaNewStatusValidation.validate(CreateNewStatus);
    if (error) {
        Toast.Show("error", error.details.map(detail => detail.message).join(', '));
        setLoading(false);
        return;
    }

    //Get Pipe Id
    var pipe = await statusService.GetPipeByName((namePipe.name).toUpperCase());

    if (pipe.obj == null) {
      Toast.Show("error", "Não foi possível encontrar esse processo.");
      setLoading(false);
      return;
    }

    CreateNewStatus.idPipe = pipe.obj.id;

    var result = await statusService.CreateStatus(CreateNewStatus);

        if (result.success === false) {
            Toast.Show("error", result.message);
            setLoading(false);
            return;
          }
      
          await getAllStatus();
          Toast.Show("success", result.message);
          setLoading(false);
  }


    //criar relação entre estados
    const CreatePossibleStatus = async () => {
        setLoading(true);

        const CreateNextStatus: CreateNextPossibleStatusDTO = {
          baseStatusId: possibleStatus?.baseStatusId ?? null,
          nextStatusId: possibleStatus?.nextStatusId ?? null,
          baseStatusName: baseStatusProps ?? null,
          nextStatusName: possibleStatus?.nextStatusName ?? null,
        };

        
        const { error } = schemaClientValidation.validate(CreateNextStatus);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setLoading(false);
            return;
        }

        
        if (!possibleStatus.nextStatusName || !baseStatusProps){
          setLoading(false);
          return;
        }

        //obter o id de cada estado
        const baseStatus = await GetStatus((baseStatusProps).toUpperCase());
        const nextStatus = await GetStatus((possibleStatus.nextStatusName).toUpperCase());

        if (!baseStatus) {
          setLoading(false);
          return;
        }

        if (!nextStatus) {
          setLoading(false);
          return;
        }

        CreateNextStatus.baseStatusId = baseStatus.id;
        CreateNextStatus.nextStatusId = nextStatus.id;

        var response = await statusService.CreateStatusRelation(CreateNextStatus);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setLoading(false);
            return;
          }
      
          Toast.Show("success", response.message);
          setLoading(false);
    }


    const GetStatus = async (name: string) => {
      setLoading(true);
      var response = await statusService.GetStatus(name);

      if (response.success === false) {
          Toast.Show("error", response.message);
          setLoading(false);
          return;
        }

        return response.obj;
  }

  useEffect(() => {
    getAllStatus();
  }, [possibleStatus.nextStatusName]);

return(
    <Layout>
        <div className='pageContainer'>
            <div className='pageHeader'>
                <span className="pageTitle">
                <PageTitle title={"Criar Estado"} allowGoBack={true} />
                </span>
            </div>
        </div>
        <div className="pageBody">
        <Row>
              <b>
                <FormattedMessage id="Screens.Status.Create" />
              </b>
          </Row>
            <Row style={{ marginTop: "15px" }}>
              <InputComponent
              xl={1.5}
              lg={3}
              md={4}
              sm={6}
              xs={12}
              style={{ width: "100%" }}
              type={"text"}
              value={newStatus.name}
              label={intl.formatMessage({ id: "Screens.Status.Info.Name" })}
              readOnly={false}
              onChange={(t: string) => setNewStatus({...newStatus!, name: t})}
              />
              <SelectComponent
              xl={2}
              lg={3}
              md={4}
              sm={6}
              xs={12}
              style={{ width: "100%", height: "43px" }}
              label={intl.formatMessage({ id: "Screens.Status.Search.Pipe" })}
              selectedItemValue={namePipe.name}
              items={pipes}
              onChange={(t: string) => {
                setNamePipe({...namePipe!, name: t})
              }}
            />
          </Row>
            <Col style={{ marginTop: "1em", display: "inline-flex", gap: "1rem" }}>
              <ButtonComponent
              loading={loading}
              text={intl.formatMessage({ id: "Screens.Status.Button.CreateStatus" })}
              onClick={() => CreateStatus()} 
              style={{ minWidth: "100px" }}/>
            </Col>
      </div>
    </Layout>
    );
}